import TrackProAPI from './track-pro-api'
import {
    DownloadParamsType,
    EditPartType,
    NonEscoPartParamsType,
    UpdateAssetDataType,
} from '../types/bucketTypes'

// Update asset statuses in bulk
const updateAssetStatuses = (payload: any, tokens: { accessToken: string; refreshToken: string }) => {
    return TrackProAPI.post('/assets/update-statuses', payload, {
        headers: {
            Authorization: `Bearer ${tokens.accessToken}`,
            refresh_token: tokens.refreshToken,
        },
    });
};

// Create ESCO asset
const createEscoAsset = (params: {
    tag_id: string;
    serial_number: string;
    tag_type: string;
    oid: string;
    stock_number?: string;
    machine_number?: string;
    longitude?: string;
    latitude?: string;
    lip_width?: string;
    class?: string;
    capacity?: string;
    equipment_type?: string;
    attachment_type?: string;
    equipment_model?: string;
}, tokens: { accessToken: string; refreshToken: string }) => {
    return TrackProAPI.post('/assets/create/esco', params, {
        headers: {
            Authorization: `Bearer ${tokens.accessToken}`,
            refresh_token: tokens.refreshToken,
        },
    });
};


// Create NON-ESCO asset (accepts FormData or object)
const createNonEscoAsset = (params: {
    tag_id: string;
    serial_number: string;
    tag_type?: string;
    oid: string;
    equipment_type?: string;
    attachment_type?: string;
    equipment_model?: string;
    make?: string;
    manufacturer?: string;
    weight?: string;
    files?: any;
    stock_number?: string;
    machine_number?: string;
    longitude?: string;
    latitude?: string;
    lip_width?: string;
    class?: string;
    capacity?: string;
}, tokens: { accessToken: string; refreshToken: string }) => {
    let headers: any = {
        Authorization: `Bearer ${tokens.accessToken}`,
        refresh_token: tokens.refreshToken,
    };
    if (params instanceof FormData) {
        headers['Content-Type'] = 'multipart/form-data';
    }
    return TrackProAPI.post('/assets/create/non-esco', params, { headers });
};

const getAssetList = () => {
    return TrackProAPI.get('/assets')
}

const getSingleAsset = (assetId: string) => {
    const endpoint = `/assets/get?asset_id=${assetId}`
    return TrackProAPI.get(endpoint)
}

const updateAsset = (assetData: UpdateAssetDataType) => {
    return TrackProAPI.post('/assets/update', assetData)
}

const addNonEscoPart = (partData: NonEscoPartParamsType) => {
    return TrackProAPI.post('/assets/replacement-parts', partData)
}

const validateAssetUpload = (file: File | null) => {
    // Create a FormData object to handle file upload
    const formData = new FormData();
    if (file != null) formData.append('file', file);
    
    // Set appropriate headers for multipart/form-data
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    
    // Send the formData in the request
    return TrackProAPI.post('/assets/validate-bulk-create', formData, config);
}

const downloadAssetAttachment = (params: DownloadParamsType) => {
    const { asset_id, file_path } = params
    const endpoint =
        '/assets/download-attachment?asset_id=' +
        asset_id +
        '&file_path=' +
        file_path
    return TrackProAPI.get(endpoint, { responseType: 'blob' })
}

const getLocationHistory = (params: any) => {
    const endpoint = '/assets/location-history'
    return TrackProAPI.get(endpoint, { params })
}

const getLocationHistoryGraph = (params: {
    asset_id: number;
    start_date?: string;
    end_date?: string;
    page_action?: string;
    end_cursor?: string;
    start_cursor?: string;
}) => {
    const endpoint = '/assets/location-history-graph'
    return TrackProAPI.get(endpoint, { params })
}

const deleteReplacementPart = async (params: any) => {
    const endpoint = '/assets/replacement-parts'
    const { data } = await TrackProAPI.delete(endpoint, {
        data: { part_id: params },
    })
    return data
}

const editReplacementPart = async (params: EditPartType) => {
    const { part_id, pmid, part_number, type, quantity, notes, description } =
        params
    const endpoint = '/assets/replacement-parts'
    const { data } = await TrackProAPI.put(endpoint, {
        part_id,
        pmid,
        part_number,
        type,
        quantity,
        notes,
        description,
    })
    return data
}

const downloadDocs = async (document_id: number) => {
    const endpoint = `/assets/download-document?document_id=${document_id}`
    const { data } = await TrackProAPI.get(endpoint, { responseType: 'blob' })
    return data
}

const transferAsset = async(asset_id: any, email: string) => {
    const endpoint = '/assets/transfer'
    const { data } = await TrackProAPI.post(endpoint, { asset_id, email })
    return data
}

const getAddressFromCoordinates = (params: {
    coordinates: Array<{
        latitude: number;
        longitude: number;
        temp_id: string;
    }>;
}, tokens: { accessToken: string; refreshToken: string }) => {
    const endpoint = '/assets/get-address-from-coordinates'
    return TrackProAPI.post(endpoint, params, {
        headers: {
            Authorization: `Bearer ${tokens.accessToken}`,
            refresh_token: tokens.refreshToken,
        },
    })
}

export default {
    getAssetList,
    updateAsset,
    addNonEscoPart,
    downloadAssetAttachment,
    getLocationHistory,
    getLocationHistoryGraph,
    deleteReplacementPart,
    editReplacementPart,
    getSingleAsset,
    downloadDocs,
    transferAsset,
    createEscoAsset,
    createNonEscoAsset,
    validateAssetUpload,
    updateAssetStatuses,
    getAddressFromCoordinates
}
